import React, { useEffect } from 'react';
import RestUtilities from '../../services/RestUtilities';

import { Grid, Paper, Box, Typography } from '@mui/material';
import TurnoverRate from './TurnoverRate';
import TurnoverAmount from './TurnoverAmount';
import { Dashboard } from '../../@types/api';
import StatsByDayChart from './StatsByDayChart';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  dashboardState,
  loadingState,
  userState,
} from '../../state/RecoilState';
import DebtorsList from './DebtorsList';
import FeedbackList from './FeedbackList';
import dayjs from 'dayjs';

const MfsDashboard = () => {
  const [dashboard, setDashboard] = useRecoilState<Dashboard | undefined>(
    dashboardState
  );
  const setLoading = useSetRecoilState(loadingState);
  const user = useRecoilValue<any>(userState);

  useEffect(() => {
    const getAllData = async () => {
      setLoading(true);
      const response = await RestUtilities.get('/api/dashboard/Get');
      if (response.ok) {
        const dashData: Dashboard = response.content;
        dashData.statsCount = {
          bookings: dashData.statsByDay.reduce(
            (p: number, c: any) => p + c.bookings,
            0
          ),
          enquiries: dashData.statsByDay.reduce(
            (p: number, c: any) => p + c.enquiries,
            0
          ),
        };

        setDashboard(dashData);
      }
      setLoading(false);
    };
    if (!dashboard) {
      getAllData();
    }
  }, [dashboard, setDashboard, setLoading]);

  if (!dashboard || user.role !== 'Administrator') return null;

  return (
    <Box maxWidth='lg'>
      <Grid container spacing={1}>
        {dashboard.debtors && (
          <Grid item xs={12}>
            <DebtorsList />
          </Grid>
        )}
        {dashboard.feedbackResponses && (
          <Grid item xs={12}>
            <FeedbackList />
          </Grid>
        )}
        <Grid item xs={12} md={12} lg={12} mb={2}>
          <Paper sx={{ px: 2, pt: 1 }}>
            <Typography
              component='h2'
              variant='h6'
              color={'primary'}
              gutterBottom
            >
              {`${dayjs().format('MMMM')}: ${
                dashboard.statsCount.bookings
              } Bookings & ${dashboard.statsCount.enquiries} Enquiries`}
            </Typography>
            <StatsByDayChart data={dashboard.statsByDay} />
          </Paper>
        </Grid>
        <Grid item xs={6} sx={{ minWidth: 550 }} mb={3}>
          <Paper sx={{ px: 2, pt: 1 }}>
            <Typography
              component='h2'
              variant='h6'
              color={'primary'}
              gutterBottom
            >
              Enquiry to Booking Conversion Rate
            </Typography>
            <TurnoverRate data={dashboard.conversions} />
          </Paper>
        </Grid>
        <Grid item xs={6} sx={{ minWidth: 550 }} mb={3}>
          <Paper sx={{ px: 2, pt: 1 }}>
            <Typography
              component='h2'
              variant='h6'
              color={'primary'}
              gutterBottom
            >
              Enquiries
            </Typography>
            <TurnoverAmount data={dashboard.conversions} />
          </Paper>
        </Grid>
        {/* <Grid item xs={12} md={4} lg={3}>
            <Paper>
              <Deposits />
            </Paper>
          </Grid> */}
      </Grid>
    </Box>
  );
};

export default MfsDashboard;
